import {
  defined
} from 'junctions-fp'
/**
 * Insctance of EffectCommand
 */
export default class EffectCommand {
  /**
   * Creates an instance of EffectCommand.
   * @param {PixelEditor} target l'objet pixeleditor
   * @param {Filter} filter un objet filter
   * @memberof EffectCommand
   */
  constructor(target, filter, filterIndex = 0) {
    if (defined(filter)) {
      this.label = 'Effect : ' + (filter.type === 'ColorEffect' ? filter.color : filter.type)
    } else {
      this.label = 'Effect : None'
    }
    this.target = target
    this.filter = filter
    this.filterIndex = filterIndex
  }
  /**
   *  Execute la command
   *
   */
  execute() {
    const canvas = this.target.canvas
    const active = canvas.getActiveObject()
    if (defined(active)) {
      if (defined(this.filter)) {
        active.filters[this.filterIndex] = this.filter
      } else {
        active.filters[this.filterIndex] = null
      }
      active.applyFilters()
      canvas.requestRenderAll()
    }
  }
  /**
   * Annule l'effet de la commande
   *
   */
  undo() {}
}



// WEBPACK FOOTER //
// ./src/model/pixel/command/EffectCommand.js